import { render, staticRenderFns } from "./FontStyle.vue?vue&type=template&id=6453805a"
import script from "./FontStyle.vue?vue&type=script&lang=js"
export * from "./FontStyle.vue?vue&type=script&lang=js"
import style0 from "./FontStyle.vue?vue&type=style&index=0&id=6453805a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports